import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Waiter } from '@app/modules/model/waiter';

import { languageSupport, languageService } from '@app/modules/common/language'
import { dataService } from '@app/modules/data';
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-waiter-thumbnail',
    templateUrl:'./ui-thumb.html',
    styleUrls: [ 
        './ui-thumb.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiWaiterThumbnail extends languageSupport implements OnInit, OnDestroy {
    @Input('waiter') _waiter: Waiter = null;

    private _subscriptions = [];

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, private data: dataService, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        if (!this._waiter){
            return;
        }
        else {
            // refresh on waiter change
            this._subscriptions.push(   
                this._waiter.OnRefresh.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );    

            // refresh on place changes
            if (this._waiter.place){
                this._subscriptions.push(   
                    this._waiter.place.OnTargetRefresh('STAFF').subscribe(
                    data => {
                        this.change.markForCheck();
                    })
                );        
            }

            // refresh on user changes
            if (this._waiter.user){
                this._subscriptions.push(   
                    this._waiter.user.OnRefresh.subscribe(
                    data => {
                        this.change.markForCheck();
                    })
                );    
            }
            
            // refresh on theme changed
            this._subscriptions.push(
                this.view.OnTheme.subscribe(
                data => {
                    this.change.markForCheck();
                })
            ); 

            // refresh every 10 seconds (for online check)
            this._subscriptions.push(   
                this.data.Clock.OnTenSecondTick.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );
        }
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    @Output('onSelect') _onSelect = new EventEmitter<any>();         
    OnSelect(){
        this._onSelect.emit(this._waiter);
    }
}
